import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { ADD_PAYMENT_CARD_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { SubmitAddCardRequestPayload, SubmitAddCardResult } from '../types/submitAddCardRequest.types';

export const submitAddCardRequest = (builder: BuilderType) =>
  builder.mutation<SubmitAddCardResult, SubmitAddCardRequestPayload>({
    query: (params) => ({
      data: params,
      method: 'POST',
      url: ADD_PAYMENT_CARD_URL,
    }),
    transformResponse: (response: GenericApiResponse<SubmitAddCardResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
